import Documents from './Doc';
import Reference from './Ref';
import ScrollToTop from './ScrollToTop';

import title from './res/title.png';

import './App.css';
import { Container, Row, Col, Nav, Navbar } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

import {
  Switch,
  Route,
  Link
} from "react-router-dom";
import { HashRouter as Router } from 'react-router-dom';

function App() {
  return (
    <div
    style={{
      backgroundColor:"#ffffff"
    }}
>
      <Router>
        <ScrollToTop />
        <Container 
        fluid
        >
          <Header />
          <Row>
              <Switch>
              <Route path="/document">
                  <Col>
                  <Documents 
                    defaultIndex = {0}
                  />
                  </Col>
                </Route>
                <Route path="/howtouse">
                  <Col>
                  <Documents 
                    defaultIndex = {2}
                  />
                  </Col>
                </Route>
                <Route path="/reference">
                  <Col>
                  <Reference />
                  </Col>
                </Route>
                <Route path="/contact">
                  <Col>
                  <Contact />
                  </Col>
                </Route>
                <Route path="/">
                  <Home />
                </Route>
                <Route>
                  <Home />
                </Route>
              </Switch>
          </Row>

          <Footer />

        </Container>
      </Router>
    </div>
  );
}


function Header() {
  return (
  <Row
  style={{
    height:60,
    backgroundColor:"#423468"
  }}>
  <Navbar 
  className="justify-content-between"
  style={{
    height:60,
    width:"100%"
  }}>
    <Nav>
      <Link 
          to="/"
          style={{
            textDecoration: "none"
          }}>
        <div
        style={{
          fontWeight:"bold",
          fontSize:30,
          color:"#e0e0ff",
          marginTop:25,
          textAlign:"center",
          textDecoration: "none"
        }}>
        AEAsAnimation
        </div>
      </Link>
    </Nav>
    <Nav
    style={{
      marginTop:35}}>
      <Nav.Link>
        <Link 
          to="document"
          style={{
            color: 'white',
            textDecoration: "none",
            fontSize:20}}
        >Document</Link>
      </Nav.Link>
      <Nav.Link>
      <Link 
        to="reference"
        style={{
          color: 'white',
          textDecoration: "none",
          fontSize:20}}>Reference</Link>
      </Nav.Link>
      <Nav.Link>
      <Link 
        to="contact"
        style={{
          color: 'white',
          textDecoration: "none",
          fontSize:20
          }}>Contact</Link>
      </Nav.Link>
    </Nav>
  </Navbar>
  </Row>
  );
}


function Footer() {
  return (
    <Row 
    className="justify-content-center"
    style={{
      backgroundColor:"#423468",
      height:100
    }}>
    </Row>
  );
}

function Home() {
  return (
      <Container 
      fluid
      style={{
        backgroundImage:`url(${title})`,
        backgroundPosition:"center",
        backgroundRepeat:"repeat"
      }}>

        <Row
        className="justify-content-center"
        style={{
          height:500
        }}>
          <p>

          <div
          style={{
            fontSize:60,
            fontWeight:"bold",
            textAlign:"center",
            color: "#ffffff",
            position:"relative",
            top:"42%"
          }}>
          AEAsAnimation
          </div>

          <div
          style={{
            fontWeight:"bold",
            textAlign:"center",
            color: "#ffffff",
            position:"relative",
            top:"45%"
          }}>
          AEAsAnimation provides the way to convert the AfterEffects animation to the Json data for Unity.
          </div>

          <div
          style={{
            textAlign:"center",
            position:"relative",
            top:"48%"
          }}>
            <Link 
              to="howtouse"
            >
            <Button 
              variant="outline-light"
              size="lg"
              style={{
                fontWeight:"bold",
                textAlign:"center",
                textDecoration: "none",
              }}
            >
              How to use
            </Button>
            </Link>
          </div>
          </p>
        </Row>

      </Container>
  );
}


function Contact() {
  return (
    <div>
    <Container>

      <Row
        style={{
          height:500
        }}>
        <Col>
          <Row
            className="justify-content-center"
          >
            <div
            style={{
              marginTop:100
            }}>

            <style type="text/css">
              {`
              .btn-custom {
                background-color: #ffffff;
                color: #5e4e89;
                border: 0.5px solid #5e4e89;
                border-radius: 10px;
              }
              `}
            </style>

              <Button 
                variant="custom" 
                size = "lg"
                href="mailto:terp_suzuki@glsui.com"
                style={{
                  fontWeight:"bold",
                  textAlign:"center",
                  textDecoration: "none",
                }}
              >
                Contact us
              </Button>

            </div>
          </Row>
          <Row
            className="justify-content-center"
          >
            <div
            style={{
              marginTop:20
            }}>
              (mail to terp_suzuki@glsui.com)
            </div>
          </Row>
        </Col>
      </Row>

    </Container>
    </div>
  );
}

export default App;
